import { PASSWORD_RULES } from "../../hooks/user-form-schema";
import { ValidationRule } from "./validation-rule";

interface PasswordRulesProps {
  password: string;
  confirmPassword?: string;
  isEditMode: boolean;
}

export function PasswordRules({
  password,
  confirmPassword,
  isEditMode,
}: PasswordRulesProps) {
  if (isEditMode && !password) {
    return (
      <div className="mt-2 p-3 bg-muted border border-border rounded-md">
        <p className="text-xs text-muted-foreground">
          Laisser vide pour conserver le mot de passe actuel
        </p>
      </div>
    );
  }

  const passwordsMatch =
    confirmPassword !== undefined ? password === confirmPassword : false;

  return (
    <div className="mt-2 p-3 bg-muted/40 border border-border rounded-md">
      <p className="text-xs font-medium mb-2">Règles de validation :</p>
      <div className="space-y-1.5">
        {PASSWORD_RULES.map((rule) => (
          <ValidationRule
            key={rule.id}
            isValid={rule.isSatisfied(password)}
            label={rule.label}
          />
        ))}
        {confirmPassword !== undefined && (
          <ValidationRule
            isValid={passwordsMatch}
            label="Les deux mots de passe correspondent"
          />
        )}
      </div>
    </div>
  );
}
